import React from "react";
import { Button } from "@mui/material";

export default function ConfirmationModal({
    heading,
    description,
    buttons = [],
    close,
    modalId
}) {

    return (
        <>
            <div className="modal-body">
                { heading ?
                    <div className="heading">
                        { heading }
                    </div>
                    : null
                }
                { description ?
                    <div className="description">
                        { description }
                    </div>
                    : null
                }
                {buttons.length > 0 ? 
                    <div className="action-buttons action-buttons-responsive">
                        <Button
                            onClick={() => close(buttons[0].confirmedValue)}
                            variant={ buttons[0].variant || "contained"}>
                            { buttons[0].label }
                        </Button>

                        {buttons.length > 1 ? 
                            <Button
                                onClick={() => close(buttons[1].confirmedValue)}
                                variant={buttons[1].variant || "outlined"}>
                                { buttons[1].label }
                            </Button>:null
                        }
                        
                    </div> : null
                }
            </div>
        </>
    );
}